/* eslint-disable */

declare interface Window {
  analytics: any;
}
